import {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {Communication, CommunicationChannel, CommunicationRequestId} from "../../../util/types";
import {selfcareCommunication} from "../../../util/request";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import SelfcarePageContent from "../../../components/selfcare/SelfcarePageContent";
import {BackButton} from "../../../components/selfcare/BackButton";
import Icon from "../../../components/selfcare/Icon";
import {formatDateTime} from "../../../util/formatter";
import LoaderSpinner from '../../../components/loaders/LoaderSpinner';
import Routing from "../../../Routing.ts";
import IconOpenInNew from "../../../components/icons/IconOpenInNew.tsx";
import setTitleAndMetaDescription from "../../../components/setTitleAndMetaDescription.tsx";

export default function ShowPage() {
    setTitleAndMetaDescription("Breve - Mit Hiper", "Her kan du se de breve og sms'er vi har sendt til dig.");

    const {customer} = useCustomer()
    const {request_id = ''} = useParams()
    const [communication, setCommunication] = useState<Communication | null>(null)

    useEffect(() => {
        selfcareCommunication(customer.customer_id, Number(request_id) as CommunicationRequestId).then(r => {
            setCommunication(r.response.data)
        })
    }, [request_id, customer.customer_id])

    if (communication === null) {
        return <LoaderSpinner/>
    }

    return <SelfcarePageContent className={'selfcare-communication'}>
        <BackButton default_url={Routing.Selfcare.Letters}/>
        <h1 className={"heading heading--montserrat"}>
            <span className={"subject"}>{communication.subject}</span>
            {communication.sent_dtm &&
                <span className={"date"}>Sendt: {formatDateTime(communication.sent_dtm)}</span>
            }
        </h1>
        {getAttachment(communication)}
        <iframe className={getIframeClass(communication.channel)} title="frame" id={'frame'} width={'100%'} onLoad={iframeLoaded}
                srcDoc={getBody(communication.body, communication.channel)}></iframe>
    </SelfcarePageContent>
}

function getBody(body: string, channel: string) {
    if (channel === CommunicationChannel.SMS) {
        return `<p style="font-family: Montserrat,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;line-height:2;">${body.replace(/(?:\r\n|\r|\n)/g, '<br />')}</p>`
    }

    return body
}

function getIframeClass(channel: string) {
    if (channel === CommunicationChannel.SMS) {
        return "iframe-sms"
    }

    return "iframe-email"
}

function iframeLoaded() {
    const iFrameID = document.getElementById('frame') as HTMLIFrameElement | null;
    if (iFrameID !== null) {
        iFrameID.style.height = "";
        if (iFrameID.contentDocument !== null) {
            iFrameID.style.height = iFrameID.contentDocument.body.scrollHeight + 40 + "px";
        }
    }
}

function getAttachment(communication: Communication | null) {
    if (communication && communication?.attachments.length > 0) {
        return (
            <div className={"attachments"}>
                {communication.attachments.map((attachment, index) => {
                    return (
                        <a href={attachment.file_uri} target="_blank" rel="noreferrer" key={index}>
                            <span className="text">
                                {attachment.external_filename}
                            </span>
                            <Icon component={IconOpenInNew}/>
                        </a>
                    )
                })}
            </div>
        )
    }
    return null;
}
